import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import DoneRoundedIcon from '@mui/icons-material/DoneRounded'
import { shouldForwardProp } from 'commons/utils/mui'

type IconProps = {
  copied: boolean
}

export const CopyButton = styled.button`
  display: flex;
  width: 14px;
  height: 14px;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${theme.shapes.borderRadius.sm};
  background: transparent;
  position: relative;
`

export const CopyIcon = styled(ContentCopyIcon, { shouldForwardProp })<IconProps>`
  position: absolute;
  color: ${theme.colors.primary.main};
  font-size: ${theme.typography.sizes.xs};
  transition: all 0.2s ease-in-out;
  transform: ${({ copied }) => (copied ? 'scale(0)' : 'scale(1)')};
`

export const DoneIcon = styled(DoneRoundedIcon, { shouldForwardProp })<IconProps>`
  position: absolute;
  color: ${theme.colors.alert.success.main};
  font-size: ${theme.typography.sizes.xs};
  transition: all 0.2s ease-in-out;
  transform: ${({ copied }) => (copied ? 'scale(1)' : 'scale(0)')};
`
